import React, { useEffect, useState } from "react";
import { Common, Roles, RolesEnum } from "../../../helper";

import "../../../assets/stlyes/Admin/EditUser.scss";

import * as commonApi from "../../../api/commonApi";
import { has } from "../../../util";

const EditUser = (props) => {
  const { isUserId, getData } = props;
  const [adminRole, setAdminRole] = useState(false)
  const [leaderRole, setLeaderRole] = useState(false)
  const [teacherRole, setTeacherRole] = useState(false)

  const fetchUserbyId = async (isUserId) => {
    const getUser = await commonApi.getUserById({ "id": isUserId });
    let user = getUser?.Items;
    if (user?.type) {
      if (has(user.type, RolesEnum.Admin)) { setAdminRole(true) }
      if (has(user.type, RolesEnum.LeadTeacher)) { setLeaderRole(true) }
      if (has(user.type, RolesEnum.Teacher)) { setTeacherRole(true) }
    }
  }

  const roleSubmit = async () => {
    let type = 0;
    type = adminRole ? type + RolesEnum.Admin : type;
    type = leaderRole ? type + RolesEnum.LeadTeacher : type;
    type = teacherRole ? type + RolesEnum.Teacher : type;
    const roleUpdate = await commonApi.assignRole({ "id": isUserId, type: type })
    if (roleUpdate) {
      getData();
    }
  }
  useEffect(() => {
    fetchUserbyId(isUserId)
  }, [isUserId])
  return (
    <div className="EditUser">
      <div className="role-checkbox">
        <span role="button" tabIndex="0" onKeyDown={null} className={adminRole ? "admin-checkbox-checked" : "admin-checkbox-unchecked"} onClick={() => setAdminRole(!adminRole)} />
        <span className="admin-checkbox-text">{Roles.Admin}</span>
      </div>
      <div className="role-checkbox">
        <span role="button" tabIndex="0" onKeyDown={null} className={leaderRole ? "admin-checkbox-checked" : "admin-checkbox-unchecked"} onClick={() => setLeaderRole(!leaderRole)} />
        <span className="admin-checkbox-text">{Roles.LeadTeacher}</span>
      </div>
      <div className="role-checkbox">
        <span role="button" tabIndex="0" onKeyDown={null} className={teacherRole ? "admin-checkbox-checked" : "admin-checkbox-unchecked"} onClick={() => setTeacherRole(!teacherRole)} />
        <span className="admin-checkbox-text">{Roles.Teacher}</span>
      </div>

      <button className="save-roles" onClick={roleSubmit}>{Common.Save}</button>
    </div>
  )
}

export { EditUser }